export const ownedTemplatesForUser = (templates = [], userId = null) => {
  if (!userId) return [];
  return (templates || []).filter((template) => template?.user_id === userId);
};
